declare var grecaptcha: any;

export const ValidateRecaptcha = () => {
	var v = grecaptcha.getResponse();

	if (v.length === 0) {

		return false;
	}

	return true;
}

export const ValidateInputs = (parent) => {
	let isValid = true

	if (parent) {
		const required = (<NodeList>parent.querySelectorAll('.required'))

		if (required.length > 0) {

			Array.prototype.forEach.call(required, (item) => {
				const inputs = item.querySelectorAll('[required]')

				Array.prototype.forEach.call(inputs, (input) => {
					const inputParent = input.closest('.formr__group')

					if (input.type === 'email') {
						if (!ValidateEmail(input.value)) {
							inputParent.classList.add('validation--error')
							isValid = false
						}
					}
					else {
						if (
							input.value === '' ||
							input.value.length <= 0
						) {
							inputParent.classList.add('validation--error')
							isValid = false
						}
					}
				})
			})
		}
	}

	return isValid
}

export const ValidateEmail = (email) => {
	const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email)
}
